import { _t } from "../../services/TranslationService.js";

export function generateRowView(getmyBets, game_id) {
  // ✅ NEW: Set bet_state = "Lost" if any row is Lost
  const hasLost =
    Array.isArray(getmyBets) &&
    getmyBets.some((b) => b?.bet_detail_status === "Lost");

  let bet = {
    bet_number: getmyBets[0].bet_number,
    game_date: getmyBets[0].created_at,
    bet_detail_status: getmyBets[0].bet_detail_status,
    bet_stake: getmyBets[0].total_sum,
    possible_win: getmyBets[0].possible_win,
    currency_name: getmyBets[0].currency_name,
    maximal_win: getmyBets[0].maximal_win,
    // ✅ Use computed bet_state (only change requested)
    bet_state: hasLost ? "Lost" : getmyBets[0].bet_detail_status,
  };

  let possibleWin =
    bet.possible_win === null
      ? parseFloat(bet.maximal_win).toFixed(2)
      : parseFloat(bet.possible_win).toFixed(2);
  let totalCoeficient = getmyBets[0].total_odd;

  let tableRowView = getmyBets
    .map(
      (bet) => `
        <tr class="border-gray-700 odd:bg-black/30 even:bg-black/50 ${
          bet.bet_detail_status === "Lost"
            ? "text-[#fd2c2c]"
            : bet.bet_detail_status === "Won"
            ? "text-[#00e92c]"
            : "text-white"
        }">
            <td class="px-2 py-1 border-r border-dotted border-[#525252]">${
              bet.game_code || "-"
            }</td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${new Date(bet.game_date).toLocaleDateString("en-GB")}
            </td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${bet.home_team} - ${bet.away_team}
            </td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${bet.market_option_name}
            </td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${bet.market_name}
            </td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${bet.coeficient_value}
            </td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${bet.game_result || "-"}
            </td>
            <td class="px-2 py-1 border-r border-dotted border-[#525252] text-center">
                ${"-"}
            </td>
            <td class="px-2 py-1 text-center">
                ${bet.current_result || "-"}
            </td>
        </tr>
    `
    )
    .join("");

  let myBetRowView = `
        <div class="w-[1100px] flex flex-row flex-nowrap bg-gradient-to-b from-[rgba(43,43,43,1)] to-[rgba(68,68,68,1)] shadow-[0px_2px_5px_2px_#000]">
            <div class="w-full flex flex-col flex-wrap pr-3 max-w-[calc(100%-300px)]">
                <div class="accountBalanceContentHeader bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md shadow-black py-1 w-full flex flex-wrap flex-row text-white items-center justify-center mt-10 first:mt-0 m-t-6">
                    <span class="text-[12px] font-bold">Biletat</span>
                </div>
                <div class="flex w-full flex-row flex-wrap text-[12px] font-bold text-center shadow-[0px_2px_5px_2px_#000] text-white [text-shadow:1px_1px_1px_#000] bg-gradient-to-b from-[rgba(43,43,43,1)] to-[rgba(68,68,68,1)]">
                    <div class="grid grid-cols-4 w-full border-b border-[#525252] py-[1px]">
                        <div>
                            <span class="">Nr. Biletash</span>
                        </div>
                        <div>
                            <span class="">Data</span>
                        </div>
                        <div>
                            <span class="">Ora</span>
                        </div>
                        <div>
                            <span class="">Statusi</span>
                        </div>
                    </div>
                    <div class="grid grid-cols-4 w-full border-b border-[#525252] py-[1px] mb-2 text-[14px]">
                        <div>
                            <span class="">${bet.bet_number}</span>
                        </div>
                        <div>
                            <span class="">${new Date(
                              bet.game_date
                            ).toLocaleDateString("en-GB")}</span>
                        </div>
                        <div>
                            <span class="">${new Date(
                              bet.game_date
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })}</span>
                        </div>
                        <div>
                            <span class="${
                              bet.bet_state === "Won"
                                ? "text-[#00e92c]"
                                : bet.bet_state === "Lost"
                                ? "text-[#fd2c2c]"
                                : "text-white"
                            }">
                                ${
                                  bet.bet_state === "Won"
                                    ? "Fituese"
                                    : bet.bet_state === "Lost"
                                    ? "Humbese"
                                    : "Ne pritje"
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mt-2 shadow-[0px_2px_5px_2px_#000] bg-[#222222] mb-2">
                    <div class="accountBalanceContentHeader bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] py-1 w-full flex flex-wrap flex-row text-white items-center justify-center mt-10 first:mt-0 shadow-[0px_2px_5px_2px_#000]">
                        <span class="text-[12px] font-bold">Biletat</span>
                    </div>
                    <div class="w-full p-1 h-[300px] overflow-y-auto">
                        <table class="w-full text-left text-[11px]">
                            <thead class="bg-black/70">
                                <tr class="">
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252]">Kodi</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Data</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Ndeshje</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Poz</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Shpjegim</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Koefi</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Rezultati</th>
                                    <th class="px-2 py-1 font-bold text-white border-r border-dotted border-[#525252] text-center">Rez Ekstra</th>
                                    <th class="px-2 py-1 font-bold text-white text-center">RezKurUVendos</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tableRowView}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="bg-black/50 flex flex-row flex-wrap shadow-[0px_2px_5px_2px_#000]">
                    <div class="border-b border-dotted border-[#525252] w-full text-white p-1 px-2">
                        <span>Luajtur: <span class="">${parseFloat(
                          bet.bet_stake
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} ${bet.currency_name}</span></span>
                    </div>
                    <div class="border-b border-dotted border-[#525252] w-full text-white p-1  px-2 flex flex-row flex-wrap justify-between mb-2">
                        <span class="">Koeficienti: <span class="">${totalCoeficient}</span></span>
                        <span class="">Fitimi Mundshëm: <span class="">${parseFloat(
                          possibleWin
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} ${bet.currency_name}</span></span>
                    </div>
                </div>
            </div>
            <div class="flex flex-col flex-wrap w-full shadow-[0px_2px_5px_2px_#000] w-[300px]">
                <div class="accountBalanceContentHeader bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md shadow-black py-1 w-full flex flex-wrap flex-row text-white items-center justify-center mt-10 first:mt-0 m-t-6">
                    <span class="text-[12px] font-bold">Biletat</span>
                </div>
                <div class="flex flex-col flex-wrap w-full">
                    <div class="flex flex-wrap flex-row w-full p-1 border-b border-[#525252]">
                        <p class="w-full font-bold text-white text-[12px]">Ne pritje... </p>
                        <p class="text-white text-[11px] font-normal">Bileta është e pa mbyllur. Disa prej ndeshjeve mund të jenë mbyllur por bileta është akoma në lojë.</p>
                    </div>
                    <div class="flex flex-wrap flex-row w-full p-1 border-b border-[#525252]">
                        <p class="w-full font-bold text-white text-[12px] text-[#fd2c2c]">Nuk Fiton</p>
                        <p class="text-white text-[11px] font-normal">Bileta NUK fiton. Një ose disa nga ndeshjet e luajtura në këtë skedinë janë të dështuara.</p>
                    </div>
                    <div class="flex flex-wrap flex-row w-full p-1 border-b border-[#525252]">
                        <p class="w-full font-bold text-white text-[12px] text-[#00e92c]">Fiton</p>
                        <p class="text-white text-[11px] font-normal">Bileta është shpallur fituese nga kompania.</p>
                    </div>
                    <div class="flex flex-wrap flex-row w-full p-1 border-b border-[#525252]">
                        <p class="w-full font-bold text-white text-[12px] text-[#0091EE]">Anuluar</p>
                        <p class="text-white text-[11px] font-normal">Bileta është anulluar nga vetë operatori.</p>
                    </div>
                    <div class="flex flex-wrap flex-row w-full p-1 border-b border-[#525252]">
                        <p class="w-full font-bold text-white text-[12px] text-[#0091EE]">Refuzuar</p>
                        <p class="text-white text-[11px] font-normal">Bileta nuk është pranuar nga kompania.</p>
                    </div>
                    <div class="flex flex-wrap flex-row w-full p-1 items-center justify-center my-6 space-x-2">
                        <button class="printTicket bg-[rgba(0,0,0,0.4)] border border-[rgba(255,255,255,1)] text-white px-[10px] w-auto h-[30px] cursor-pointer leading-[30px] text-[12px] ${
                          bet.bet_state === "Approved" ? "" : "hidden"
                        }" id="${game_id}">Printo Bileten</button>
                        <button class="closeViewBet bg-[rgba(0,0,0,0.4)] border border-[rgba(255,255,255,1)] text-white px-[10px] w-auto h-[30px] cursor-pointer leading-[30px] text-[12px]">Mbyll</button>
                    </div>
                </div>
            </div>
        </div>
    `;

  return myBetRowView;
}
